module.exports = __webpack_public_path__ + "img/default_avatar.92027116.png";